module.exports = {
  "zones": {
    "Africa/Sao_Tome": ["z", {
      "wallclock": 1546308000000,
      "format": "GMT",
      "abbrev": "GMT",
      "offset": 0,
      "posix": 1546304400000,
      "save": 0
    }, {
      "wallclock": 1514768400000,
      "format": "WAT",
      "abbrev": "WAT",
      "offset": 3600000,
      "posix": 1514768400000,
      "save": 0
    }, {
      "wallclock": -1830386205000,
      "format": "GMT",
      "abbrev": "GMT",
      "offset": 0,
      "posix": -1830384000000,
      "save": 0
    }, {
      "wallclock": -2713910400000,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -2205000,
      "posix": -2713912016000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 1616000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};